<!-- Translated: no -->
<template>
  <Modal @close="closeModal" :wide="false" :show-close="true">
    <div slot="header">
      <div class="modal-header">
        <div class="heading">
          <h1>QR-koder</h1>
        </div>
      </div>
    </div>

    <div class="qr-code-wrapper" v-if="hasValidCodes && hasCodes">
      <div class="qr-code" v-for="(code, index) in params.order.qrCodes" v-bind:key="index">
        <h3>{{ code.product }}</h3>
        <img class="qr" :src="qrUrl(code.ordernumber)" />
        <span>{{ code.ordernumber }}</span>
      </div>
    </div>

    <div v-if="!hasValidCodes && hasCodes">
      <p>QR-koderna aktiveras några dagar innan ankomst.</p>
    </div>

    <div v-if="!hasValidCodes && !hasCodes">
      <p>Det finns inga giltiga QR-koder.</p>
    </div>

    <button style="margin-top: 50px;" class="small white border" @click="closeModal" v-if="isCreating">Stäng</button>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'openModal',
    ]),
    qrUrl(ordernumber) {
      return `${window.API_URL}/api/v1/qr?code=${ordernumber}&size=200`;
    },
  },
  computed: {
    hasValidCodes() {
      return this.params.order.qrCodes.map(code => !!code.ordernumber)
        .filter(code => code).length > 0;
    },
    hasCodes() {
      return this.params.order.qrCodes.length > 0;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.qr-code-wrapper
  display: flex
  flex-wrap: wrap
  justify-content: center
  .qr-code
    display: flex
    flex-direction: column
    align-items: center
    margin: 30px
    span
      margin 6px 0
      line-height: 1em
</style>



// WEBPACK FOOTER //
// QrModal.vue?42b0c3ae